import icon from 'vue-svgicon';

icon.register({
    'bold/controls-pause': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<rect pid="0" x="3" y="1" width="7" height="22" rx="1.5" ry="1.5"/><rect pid="1" x="14" y="1" width="7" height="22" rx="1.5" ry="1.5"/>`,
    },
});
